// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZhihuOutlinedSvg from "@fishx/icons-svg/es/asn/ZhihuOutlined";
import FishxIcon from '../components/FishxIcon';

var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuOutlinedSvg
  }));
};

ZhihuOutlined.displayName = 'ZhihuOutlined';
export default React.forwardRef(ZhihuOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ZhihuOutlined.js
// module id = 4432
// module chunks = 0